export const INITIAL_QUARTERS_REQUEST = "INITIAL_QUARTERS_REQUEST";
export const FETCH_QUARTERS_SUCCESS = "FETCH_QUARTERS_SUCCESS";
export const FINAL_QUARTERS_REQUEST = "FINAL_QUARTERS_REQUEST";
